export default __webpack_public_path__ + "static/media/review_7.36a55cad.webp";